module.exports = __webpack_public_path__ + "static/img/h4-1.a394dc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/h4-1.png
// module id = jGPU
// module chunks = 1